module.exports = __webpack_public_path__ + "img/crayon.be5030ca.webp";